function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
/* eslint no-unused-vars: "off" */
import GridModel from "./GridModel.js";
import GridRange from "./GridRange.js";
/**
 * Mock model implementing GridModel for testing out grid functionality
 */
class MockGridModel extends GridModel {
  constructor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$rowCount = _ref.rowCount,
      rowCount = _ref$rowCount === void 0 ? 1000000000 : _ref$rowCount,
      _ref$columnCount = _ref.columnCount,
      columnCount = _ref$columnCount === void 0 ? 100 : _ref$columnCount,
      _ref$floatingTopRowCo = _ref.floatingTopRowCount,
      floatingTopRowCount = _ref$floatingTopRowCo === void 0 ? 0 : _ref$floatingTopRowCo,
      _ref$floatingBottomRo = _ref.floatingBottomRowCount,
      floatingBottomRowCount = _ref$floatingBottomRo === void 0 ? 0 : _ref$floatingBottomRo,
      _ref$floatingLeftColu = _ref.floatingLeftColumnCount,
      floatingLeftColumnCount = _ref$floatingLeftColu === void 0 ? 0 : _ref$floatingLeftColu,
      _ref$floatingRightCol = _ref.floatingRightColumnCount,
      floatingRightColumnCount = _ref$floatingRightCol === void 0 ? 0 : _ref$floatingRightCol,
      _ref$isEditable = _ref.isEditable,
      isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
      _ref$editedData = _ref.editedData,
      editedData = _ref$editedData === void 0 ? [] : _ref$editedData;
    super();
    _defineProperty(this, "numRows", void 0);
    _defineProperty(this, "numColumns", void 0);
    _defineProperty(this, "floatingTop", void 0);
    _defineProperty(this, "floatingBottom", void 0);
    _defineProperty(this, "floatingLeft", void 0);
    _defineProperty(this, "floatingRight", void 0);
    _defineProperty(this, "editable", void 0);
    _defineProperty(this, "editedData", void 0);
    this.numRows = rowCount;
    this.numColumns = columnCount;
    this.floatingTop = floatingTopRowCount;
    this.floatingBottom = floatingBottomRowCount;
    this.floatingLeft = floatingLeftColumnCount;
    this.floatingRight = floatingRightColumnCount;
    this.editable = isEditable;
    this.editedData = editedData;
  }
  get rowCount() {
    return this.numRows;
  }
  get columnCount() {
    return this.numColumns;
  }
  get floatingTopRowCount() {
    return this.floatingTop;
  }
  get floatingBottomRowCount() {
    return this.floatingBottom;
  }
  get floatingLeftColumnCount() {
    return this.floatingLeft;
  }
  get floatingRightColumnCount() {
    return this.floatingRight;
  }
  get isEditable() {
    return this.editable;
  }
  textForCell(column, row) {
    var _this$editedData$colu, _this$editedData$colu2;
    return (_this$editedData$colu = (_this$editedData$colu2 = this.editedData[column]) === null || _this$editedData$colu2 === void 0 ? void 0 : _this$editedData$colu2[row]) !== null && _this$editedData$colu !== void 0 ? _this$editedData$colu : "".concat(column, ",").concat(row);
  }
  colorForCell(column, row, theme) {
    return theme.textColor;
  }
  textForColumnHeader(column) {
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return "".concat(column);
  }
  textForRowHeader(row) {
    return "".concat(row);
  }
  textForRowFooter(row) {
    return "".concat(row);
  }
  setValueForCell(column, row, value) {
    var _this = this;
    return _asyncToGenerator(function* () {
      if (_this.editedData[column] == null) {
        _this.editedData[column] = [];
      }
      _this.editedData[column][row] = "".concat(value);
    })();
  }
  setValueForRanges(ranges, text) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      GridRange.forEachCell(ranges, (x, y) => {
        _this2.setValueForCell(x, y, text);
      });
    })();
  }
  setValues(edits) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      for (var i = 0; i < edits.length; i += 1) {
        var _edit$column, _edit$row;
        var edit = edits[i];
        _this3.setValueForCell((_edit$column = edit.column) !== null && _edit$column !== void 0 ? _edit$column : edit.x, (_edit$row = edit.row) !== null && _edit$row !== void 0 ? _edit$row : edit.y, edit.text);
      }
    })();
  }
  editValueForCell(column, row) {
    return this.textForCell(column, row);
  }
  isValidForCell(column, row, value) {
    return true;
  }
  isEditableRange(range) {
    return this.isEditable;
  }
  delete(ranges) {
    throw new Error('Method not implemented.');
  }
}
export default MockGridModel;
//# sourceMappingURL=MockGridModel.js.map